import { Loader } from '../Widgets';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Employee } from 'service/Models';
import ServerGateway from 'service/ServerGateway';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

export const TodoList = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [month, setMonth] = useState<string>(moment().format("YYYY-MM"));
    const [todos, setTodos] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        loadTodos();
    }, []);

    const handleMonthChange = (e) => {
        setMonth(e.target.value);
    }

    useEffect(() => {
        loadTodos();
    }, [month]);

    const loadTodos = () => {
        if (month) {
            setIsLoading(true);
            ServerGateway
                .getTodos(moment(month + "-01").year(), (moment(month + "-01").month() + 1))
                .then((data) => {
                    setTodos(data);
                    setIsLoading(false);
                })
                .catch(error => {
                    console.log(error);
                    setIsLoading(false);
                });
        }
    }

    return (
        <div className="page-todo-list">
            <div className='container'>
                <div className='row' style={{ marginBottom: "20px" }}>
                    <div className='col-md-12'>
                        <input type="month" className="form-control" value={month} onChange={handleMonthChange} max={moment().format("YYYY-MM")} style={{ textAlign: "center" }}></input>
                    </div>
                </div>
                {isLoading &&
                    <Loader />
                }
                {!isLoading &&
                    <>
                        {(todos.length == 0) &&
                            <div className="alert alert-secondary" role="alert">
                                <FontAwesomeIcon icon={faCircleInfo} style={{ marginRight: 10 }} />
                                No tasks available
                            </div>
                        }
                        {(todos.length > 0) &&
                            <ul className="list-group list-group-flush">
                                {todos && todos.map((todo) => (
                                    <li className="list-group-item card" style={{ marginBottom: "20px" }}>
                                        <ul className="list-group list-group-flush">
                                            <li className="list-group-item">
                                                <div className="fw-bold" style={{ fontSize: "1.2rem" }}>
                                                    {todo.task}
                                                </div>
                                            </li>
                                            <li className="list-group-item">
                                                Date
                                                <div className="fw-bold">
                                                    {moment(todo.dueDate).format("DD MMM YYYY")}
                                                </div>
                                            </li>
                                            <li className="list-group-item">
                                                Status
                                                <div className="fw-bold">
                                                    {moment(todo.dueDate).isSameOrAfter(moment(), 'day') &&
                                                        <>
                                                            {todo.isDone ?
                                                                <span className="badge bg-success">Done</span> :
                                                                <span className="badge bg-warning">Upcoming</span>}
                                                        </>
                                                    }
                                                    {!moment(todo.dueDate).isSameOrAfter(moment(), 'day') &&
                                                        <>
                                                            {todo.isDone ?
                                                                <span className="badge bg-success">Done</span> :
                                                                <span className="badge bg-danger">Pending</span>}
                                                        </>
                                                    }
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                ))}
                            </ul>
                        }
                    </>
                }
            </div>
        </div>
    );
}